import { Box } from '@chakra-ui/react'
import { useRefUpdated } from 'ui/hooks/useRefUpdated'
import { useEffect, useRef } from 'react'
import { type Option, type QliroOrder } from 'ecosystem'

export interface QliroCheckoutProps {
  qliroOrder?: Option<QliroOrder>
  onReady?: () => void
}

/** @see https://developers.qliro.com/docs/qliro-checkout/get-started/load-checkout */
export const QliroCheckout = ({ qliroOrder, onReady }: QliroCheckoutProps) => {
  const handleIsReadyRef = useRefUpdated(onReady)
  const containerRef = useRef<HTMLDivElement>(null)

  // Define q1Ready before injecting the snippet so Qliro calls it once the iframe is rendered
  useEffect(() => {
    if (!qliroOrder?.OrderHtmlSnippet) {
      return
    }

    window.q1Ready = () => {
      handleIsReadyRef.current?.()
    }

    return () => {
      window.q1Ready = undefined
    }
  }, [handleIsReadyRef, qliroOrder?.OrderHtmlSnippet])

  // Inject the HTML snippet and execute its scripts
  useEffect(() => {
    if (containerRef.current && qliroOrder?.OrderHtmlSnippet) {
      const fragment = document.createRange().createContextualFragment(qliroOrder.OrderHtmlSnippet)
      containerRef.current.replaceChildren(fragment)
    }
  }, [qliroOrder?.OrderHtmlSnippet])

  if (!qliroOrder?.OrderHtmlSnippet) {
    return null
  }

  return (
    <Box maxW="502px" mx="auto" width="100%">
      <div ref={containerRef} />
    </Box>
  )
}
